import type { ReactNode } from 'react';

/** Indicador (C-19): rótulo, valor grande e linha de apoio. */
export default function Kpi({ label, value, suffix, sub }: { label: string; value: ReactNode; suffix?: ReactNode; sub?: ReactNode }) {
  return (
    <div className="kpi">
      <div className="k">{label}</div>
      <div className="v">{value}{suffix && <small>{suffix}</small>}</div>
      {sub && <div className="s">{sub}</div>}
    </div>
  );
}
